import { QueryKey, useQuery } from '@tanstack/react-query';

import { getCmsContent } from '../cms/client';
import { UseZepApiQueryOptions } from '../zep-api';

export const QUERY_KEY_CMS = 'cms';

export function useCmsContent<
  TQueryFnData extends readonly any[] | Record<string, any> = never,
  TData = TQueryFnData,
>(contentId: string, options?: UseZepApiQueryOptions<TQueryFnData, TData>) {
  return useQuery(
    [QUERY_KEY_CMS, contentId] as QueryKey,
    () => getCmsContent<TQueryFnData>({ contentId }),
    options,
  );
}
